// Version history service
// This service provides version history data for the application
// It can be extended to fetch data from an API in the future

class VersionHistoryService {
  // For now, return a static list of versions
  // This could be replaced with an API call in the future
  // Comming Soon: 
    // - Microsoft Single Sign-On at the login screen 

  static getVersionHistory() {
    return [
      {
        version: "0.6",
        date: "May 27, 2025",
        changes: [
          "Lock previous weeks’ entries to prevent editing ",
          "Add Group No. as a column to the GL View",
          "Clearer Studio labels in the GL View",
          "Sort studio entries by Studio Name in the GL View",
          "Add new filters to PM View"
        ]
      },
      {
        version: "0.5",
        date: "May 9, 2025",
        changes: [
          "Keep selected week locked when switching between views",
          "Implement data pipeline to fetch Milestone and Contact data from MS Fabric/Salesforce",
          "Prevent users from navigating away from the Main View when entries have not been saved",
          "Allow project entries to be editable on GL View"
        ]
      },
      {
        version: "0.4",
        date: "April 10, 2025",
        changes: [
          "Update Main View to display '% EAC Labor Used' values correctly",
          "Updated project search to include more rows",
          "Update the app to default to the following week",
          "Update so that refreshing the page does not redirect users to the Main View",
          "Update GL View so 'All Groups' mode displays the correct week data",
          "Improve refresh rate on GL View",
          "Add “Available Hours” fields on the Main and GL Views"
        ]
      },
      {
        version: "0.3",
        date: "April 3, 2025",
        changes: [
          "Main View:",
            "Each week now starts with five blank rows by default",
            "Columns widths adjusted to improve legibility",
            "Projects are now searchable by name AND number",
            "Project dropdown lists now display Project Number, Name, and Milestone Name",
            "Temporarily replaced '% EAC Labor Used' with 'Reported % Complete'",
          "PM View:",
            "Overhauled display of project entries",
            "Project entries are now grouped by Project Manager",
          "GL View:",
            "Added option to filter entries by Studio",
            "Increased the width of the “Time Entries” table and incorporated remarks",
            "Added “Group by Projects” option to allow Group/Studio leaders to see what projects their teams plan to work on."
        ]
      },
      {
        version: "0.2",
        date: "March 24, 2025",
        changes: [
          "Fix ratio B calculation", 
          "Remove the magnifying glass icon from Project No column or move to be inline with the input cell",
          "Swap the column width values between Planned Hours and Remarks",
          "Update GL view so the Time Entries table is wider"
        ]
      },
      {
        version: "0.1",
        date: "March 20, 2025",
        changes: [
          "Initial release of the application",
        ]
      }
    ];
  }

  // Get the current version of the application
  static getCurrentVersion() {
    const versions = this.getVersionHistory();
    return versions.length > 0 ? versions[0].version : "Unknown";
  }
}

export default VersionHistoryService;
